import React from 'react'

import "./FeaturedLogos.css";

import craig_n_dave from "../../../images/components/FeaturedLogos/craig_n_dave.svg";
import first_news from "../../../images/components/FeaturedLogos/first_news.svg";
import hello_world from "../../../images/components/FeaturedLogos/hello_world.svg";
import learning_dust from "../../../images/components/FeaturedLogos/learning_dust.svg";
import real_python from "../../../images/components/FeaturedLogos/real_python.svg";
import cas from "../../../images/components/FeaturedLogos/cas.svg";
import teaching_python from "../../../images/components/FeaturedLogos/teaching_python.svg";
import idea from "../../../images/components/FeaturedLogos/idea.svg";


function FeaturedLogos(){
    return(
      	<div className="featured-logos">

			<div className="featured-logo-container">
				<a href="https://www.computingatschool.org.uk/forum-news-blogs/2024/april/mission-encodeable-making-programming-fun-secondary-tc-meeting/" target="_blank" rel="noreferrer"><img src={cas} alt="CAS" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<a href="https://www.youtube.com/watch?v=uXj-6WQ8s2U" target="_blank" rel="noreferrer"><img src={craig_n_dave} alt="Craig 'N' Dave" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<img src={first_news} alt="First News" loading="lazy" />
			</div>

			<div className="featured-logo-container">
				<a href="https://downloads.ctfassets.net/oshmmv7kdjgm/5zkHUMOcCFRiFwLG3oc1Gu/e98b0533f5b25fb682f54db9c38768ea/HelloWorld19.pdf" target="_blank" rel="noreferrer"><img src={hello_world} alt="Hello World" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<a href="https://idea.org.uk/blog/idea-learners-set-up-own-website-to-help-" target="_blank" rel="noreferrer"><img src={idea} alt="iDEA" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<a href="https://open.spotify.com/episode/5NiHnYrYGsrH9TZWuGBeas?si=2e1611217f414745" target="_blank" rel="noreferrer"><img src={learning_dust} alt="Learning_Dust" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<a href="https://realpython.com/podcasts/rpp/120/" target="_blank" rel="noreferrer"><img src={real_python} alt="Real Python" loading="lazy" /></a>
			</div>

			<div className="featured-logo-container">
				<a href="https://www.teachingpython.fm/93" target="_blank" rel="noreferrer"><img src={teaching_python} alt="Teaching Python" loading="lazy" /></a>
			</div>

      </div>
    )
}

export default FeaturedLogos;
